import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const FullscreenButton = ({ handleDialogOpen }) => {
  return (
    <Tooltip title='Fullscreen Mode'>
      <IconButton color='primary' onClick={handleDialogOpen} sx={{ ml: 1 }}>
        <FullscreenIcon />
      </IconButton>
    </Tooltip>
  );
};

export default FullscreenButton;
